import LegalLayout, { LEGAL_META } from "./LegalLayout";

const { COMPANY, CONTACT_EMAIL } = LEGAL_META;

export default function Privacidad() {
  return (
    <LegalLayout
      title="Política de Privacidad"
      subtitle={`En ${COMPANY} nos comprometemos a proteger tu privacidad y a tratar tus datos personales con transparencia, cumpliendo la Ley N° 19.628 y la Ley N° 21.719 (Nueva Ley de Protección de Datos Personales de Chile).`}
    >
      <h2>1. Responsable del tratamiento</h2>
      <p>
        <strong>{COMPANY}</strong> es el responsable del tratamiento de los datos personales recolectados a través de la
        plataforma SIGSAOP y de los formularios públicos disponibles en el sitio (por ejemplo, "Solicitar demo").
        Para ejercer tus derechos o realizar consultas, escribe a <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
      </p>

      <h2>2. Datos personales que tratamos</h2>
      <h3>2.1 Formulario "Solicitar demo" (visitantes del sitio)</h3>
      <ul>
        <li>Nombre completo</li>
        <li>Correo electrónico corporativo</li>
        <li>Teléfono de contacto</li>
        <li>Empresa u organización</li>
        <li>Mensaje libre (opcional)</li>
        <li>Metadatos técnicos: dirección IP, user-agent y fecha de envío (usados solo para prevenir abusos)</li>
      </ul>

      <h3>2.2 Usuarios de la Plataforma (clientes contratantes)</h3>
      <ul>
        <li>Datos de identificación: nombre completo, email, cargo, teléfono.</li>
        <li>Datos de autenticación: contraseña (almacenada mediante <em>hashing</em> bcrypt, nunca en texto plano).</li>
        <li>Registros de actividad (auditoría): acciones realizadas dentro de la plataforma, fecha, usuario responsable.</li>
        <li>Datos operativos ingresados por el Cliente: comunidades, dirigentes, autoridades, contactos institucionales,
          compromisos, reuniones, evidencia adjunta.</li>
      </ul>

      <h3>2.3 Datos de terceros ingresados por el Cliente</h3>
      <p>
        Cuando el Cliente registra información de terceros (por ejemplo, líderes comunitarios, autoridades, contrapartes),
        el Cliente actúa como responsable del tratamiento respecto a esos terceros y se compromete a contar con la base
        de licitud correspondiente. {COMPANY} actúa como <strong>encargado del tratamiento</strong> respecto de esos datos.
      </p>

      <h2>3. Finalidades del tratamiento</h2>
      <ul>
        <li><strong>Prestación del servicio SIGSAOP:</strong> permitir el acceso a la plataforma y sus funcionalidades.</li>
        <li><strong>Contacto comercial:</strong> responder solicitudes de demostración y consultas.</li>
        <li><strong>Seguridad:</strong> detectar y prevenir accesos indebidos, fraudes y abusos.</li>
        <li><strong>Cumplimiento legal:</strong> responder requerimientos de autoridades competentes.</li>
        <li><strong>Mejora del servicio:</strong> analizar estadísticas agregadas y anonimizadas de uso.</li>
      </ul>
      <p>
        <strong>No utilizamos tus datos personales para publicidad de terceros, no los vendemos, ni los cedemos</strong>
        a compañías con fines comerciales ajenos a la prestación del servicio.
      </p>

      <h2>4. Base de licitud (Ley 21.719 art. 12)</h2>
      <ul>
        <li><strong>Consentimiento libre, informado, previo, específico e inequívoco</strong> del titular, otorgado
          explícitamente al enviar el formulario "Solicitar demo" y aceptar esta política.</li>
        <li><strong>Ejecución de un contrato</strong> comercial con el Cliente o para adoptar medidas precontractuales.</li>
        <li><strong>Cumplimiento de una obligación legal</strong> que recaiga sobre {COMPANY}.</li>
        <li><strong>Interés legítimo</strong> del responsable en garantizar la seguridad de la plataforma.</li>
      </ul>

      <h2>5. Derechos del titular (Ley 21.719 arts. 4°-8°)</h2>
      <p>Como titular de los datos, tienes derecho a:</p>
      <ul>
        <li><strong>Acceso:</strong> saber qué datos tuyos tratamos y con qué finalidad.</li>
        <li><strong>Rectificación:</strong> exigir la corrección de datos inexactos o incompletos.</li>
        <li><strong>Supresión (derecho al olvido):</strong> solicitar la eliminación de tus datos.</li>
        <li><strong>Oposición:</strong> oponerte al tratamiento por motivos legítimos.</li>
        <li><strong>Portabilidad:</strong> recibir tus datos en un formato estructurado y de uso común.</li>
        <li><strong>Bloqueo:</strong> suspender temporalmente el tratamiento mientras se resuelve una controversia.</li>
        <li><strong>Retiro del consentimiento:</strong> en cualquier momento, sin efecto retroactivo.</li>
      </ul>
      <p>
        Para ejercer estos derechos, escribe a <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a> indicando
        claramente el derecho que ejerces y adjuntando prueba de tu identidad. Responderemos dentro del plazo legal
        (máximo 30 días corridos).
      </p>

      <h2>6. Conservación de los datos</h2>
      <ul>
        <li>Datos del formulario "Solicitar demo": hasta 24 meses desde el último contacto comercial.</li>
        <li>Datos operativos del Cliente: durante toda la vigencia del contrato y hasta 30 días posteriores a su
          terminación, período en el cual podrás exportarlos.</li>
        <li>Logs de auditoría: hasta 3 años por razones de seguridad y cumplimiento.</li>
      </ul>

      <h2>7. Encargados y proveedores (subcontrataciones)</h2>
      <p>
        Para operar SIGSAOP contratamos proveedores tecnológicos que actúan como encargados del tratamiento bajo
        estrictos acuerdos de confidencialidad y seguridad:
      </p>
      <ul>
        <li><strong>Supabase (Postgres + Storage):</strong> almacenamiento cifrado de datos y archivos.</li>
        <li><strong>Amazon Web Services (AWS):</strong> hosting de la infraestructura.</li>
        <li><strong>Resend:</strong> envío de correos transaccionales y notificaciones.</li>
      </ul>
      <p>
        Estos proveedores pueden almacenar datos fuera de Chile. En dichos casos aseguramos que el país destino ofrezca
        un nivel adecuado de protección o hemos adoptado cláusulas contractuales tipo conforme a lo dispuesto por la
        Agencia de Protección de Datos Personales.
      </p>

      <h2>8. Medidas de seguridad</h2>
      <p>Aplicamos medidas técnicas y organizativas adecuadas:</p>
      <ul>
        <li>Cifrado TLS 1.2+ en todas las conexiones.</li>
        <li>Cifrado en reposo de la base de datos y del almacenamiento de archivos.</li>
        <li>Contraseñas almacenadas con bcrypt (nunca en texto plano).</li>
        <li>Autenticación JWT con expiración de sesión.</li>
        <li>Control de accesos por rol (RBAC) y aislamiento multi-tenant.</li>
        <li>Backups automáticos diarios con retención mínima de 30 días.</li>
        <li>Logs de auditoría de todas las acciones sensibles.</li>
      </ul>

      <h2>9. Notificación de brechas de seguridad</h2>
      <p>
        En caso de una brecha de seguridad que afecte datos personales, notificaremos a los titulares afectados y a la
        Agencia de Protección de Datos Personales dentro de las 72 horas de detectada, conforme al art. 32 de la Ley
        21.719.
      </p>

      <h2>10. Menores de edad</h2>
      <p>
        SIGSAOP es una herramienta de uso corporativo destinada a personas mayores de 18 años. No recolectamos datos
        personales de menores de edad de manera consciente. Si detectas que un menor ha proporcionado datos, contáctanos
        para eliminarlos.
      </p>

      <h2>11. Cookies</h2>
      <p>
        Utilizamos cookies estrictamente necesarias para el funcionamiento de la plataforma. Consulta el detalle en
        nuestra <a href="/cookies">Política de Cookies</a>.
      </p>

      <h2>12. Cambios a esta política</h2>
      <p>
        Cualquier modificación a esta política será publicada en esta misma URL con la fecha de "Última actualización".
        Cuando los cambios afecten sustantivamente el tratamiento de tus datos, te lo notificaremos por email.
      </p>

      <h2>13. Contacto y reclamos</h2>
      <p>
        Consultas y ejercicio de derechos: <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
        Adicionalmente, tienes derecho a presentar reclamo ante la <strong>Agencia de Protección de Datos Personales
        de Chile</strong> si consideras que hemos vulnerado tus derechos.
      </p>
    </LegalLayout>
  );
}
